<app-alert></app-alert>

<div *ngIf="!isVerified" class="loader">
    <h1 class="mat-h1">Verifying...</h1>
</div>
